export default __webpack_public_path__ + "static/allconnect-logo-2c806b6b3a2a5dfdc44b03ddcca276af.png";